
































import { defineComponent } from "@vue/composition-api";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";

/**
 * 下書き保存方法 選択モーダル
 */
export default defineComponent({
  components: {
    OccModal,
    OccButton,
    OccHeading
  },
  props: {
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  name: "SaveMethodSelectModal"
});
